(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kilo-farm-page"] && !Shopify.designMode) return;
  try {
    
  function setupKiloStoryMobileVideo(section) {
    const video = section.querySelector('.kilo-story__hero--video video');
    const trigger = section.querySelector('[data-kilo-story-video-trigger]');
    const hero = section.querySelector('.kilo-story__hero--video');
    const poster = section.querySelector('[data-kilo-story-video-poster]');

    if (!(video instanceof HTMLVideoElement) || video.dataset.mobileFullscreenReady === 'true') return;

    video.dataset.mobileFullscreenReady = 'true';

    const isMobileViewport = () => window.matchMedia('(max-width: 640px)').matches;

    const enterFullscreen = () => {
      if (!isMobileViewport()) return;

      if (typeof video.webkitEnterFullscreen === 'function') {
        try {
          video.webkitEnterFullscreen();
          return;
        } catch (error) {}
      }

      if (typeof video.requestFullscreen === 'function') {
        video.requestFullscreen().catch(() => {});
      }
    };

    const syncVideoState = () => {
      if (!hero) return;

      hero.classList.toggle('is-playing', !video.paused && !video.ended);
    };

    const resetToPosterState = () => {
      if (!hero?.classList.contains('has-poster')) return;

      hero.classList.remove('is-started');
      video.controls = false;
      video.setAttribute('aria-hidden', 'true');
      video.currentTime = 0;
      syncVideoState();
    };

    const startPlayback = () => {
      video.controls = true;
      hero?.classList.add('is-started');
      video.removeAttribute('aria-hidden');
      syncVideoState();

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          if (poster) resetToPosterState();
        });
      }
    };

    if (trigger instanceof HTMLButtonElement) {
      trigger.addEventListener('click', startPlayback);
    }

    video.addEventListener('play', enterFullscreen);
    video.addEventListener('play', syncVideoState);
    video.addEventListener('pause', syncVideoState);
    video.addEventListener('ended', () => {
      syncVideoState();

      if (poster) resetToPosterState();
    });

    if (poster) {
      video.setAttribute('aria-hidden', 'true');
    }

    syncVideoState();
  }

  document.querySelectorAll('.kilo-story[data-mobile-fullscreen-video]').forEach(setupKiloStoryMobileVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kilo-story-of-kilo"] && !Shopify.designMode) return;
  try {
    
  function setupKiloStoryOverlayVideo(section) {
    const frame = section.querySelector('.kilo-story__overlay-video-frame');
    const trigger = section.querySelector('[data-kilo-story-overlay-trigger]');
    const video = frame?.querySelector('video');

    if (!(frame instanceof HTMLElement) || !(trigger instanceof HTMLButtonElement) || !(video instanceof HTMLVideoElement)) return;
    if (frame.dataset.overlayVideoReady === 'true') return;

    frame.dataset.overlayVideoReady = 'true';
    video.loop = false;
    video.controls = true;
    video.muted = false;
    video.playsInline = true;

    const syncState = () => {
      frame.classList.toggle('is-playing', !video.paused && !video.ended);
    };

    const startPlayback = () => {
      frame.classList.add('is-started');
      video.controls = true;
      video.muted = false;
      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          frame.classList.remove('is-started');
          syncState();
        });
      }
    };

    trigger.addEventListener('click', startPlayback);
    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    video.addEventListener('ended', syncState);

    syncState();
  }

  document.querySelectorAll('[data-kilo-story-overlay-video]').forEach(setupKiloStoryOverlayVideo);

  } catch(e) { console.error(e); }
})();
})();
